import React, { FC } from 'react';
import ArticleBlock, { ArticleBlockProps } from '../../../components/molecules/ArticleBlock';
import { ArticleBlock as Data } from '../../../graphql/generated/api-graphql';
import { wediaImagesTransform } from '../../Common/wedia';
import { fixURL } from '../../../helpers/StringHelpers';
import { HtmlLayout } from '../../../components/atoms/Html/types';
export type ArticleBlockDataProps = {
  data: Data;
};
// we have ArticleBlock in the back and ArticleBlock in our molecules that are not the same stuff so....
const ArticleBlockWithData: FC<ArticleBlockDataProps> = ({
  data
}) => {
  console.log('src/relay/ArticleBlocks/ArticleBlock/index.tsx, data', data);
  const props: ArticleBlockProps = {
    htmlProps: data?.description ? {
      text: fixURL(data.description),
      layout: HtmlLayout.article
    } : undefined,
    pictureProps: data?.imageDesktop ? {
      maxWidth: 910,
      withHD: true,
      alt: data.imageDesktop.alt ?? '',
      images: [...(data?.imageDesktop ? wediaImagesTransform(data?.imageDesktop) ?? [] : [])].filter(Boolean)
    } : undefined
  };
  return <ArticleBlock {...props} />;
};
export default ArticleBlockWithData;